import { useState } from 'react'

import { Box, Button, List } from '@factorialco/deprecated-design-system'
import { CustomCategoriesPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import CategoryBlock from 'modules/finance/components/CustomCategories/CategoryBlock'
import CreateCustomCategoryModal from 'modules/finance/components/CustomCategories/CreateCustomCategoryModal'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const CustomCategoriesPage = () => {
  const [addCustomCategoryModalOpen, setAddCustomCategoryModalOpen] = useState(false)

  const { company } = useCurrentSession()

  const { data, loading, error } = useQuery(CustomCategoriesPageDocument, {
    variables: {
      companyIds: [company.id],
    },
  })

  const categories = data?.finance?.customCategoriesConnection.nodes ?? []
  const legalEntities = data?.companies?.legalEntitiesConnection.nodes ?? []
  const canSeeCustomCategoriesSettings =
    data?.finance?._policies?.settingsSeeAccountingSettingsCustomCategories?.can ?? false
  const canManageCustomCategoriesAccounts =
    data?.finance?._policies?.accountingManageCustomCategoriesAccounts?.can ?? false

  return (
    <ResponsivePage.Body
      loading={loading}
      error={error}
      authorized={canSeeCustomCategoriesSettings}
      widget={
        <Button iconName="add" type="secondary" onClick={() => setAddCustomCategoryModalOpen(true)}>
          {i18n.t('finance.settings.accounting.custom_categories.actions.add_subcategory')}
        </Button>
      }
    >
      <Box paddingX="s24">
        {categories.length > 0 && (
          <List>
            {categories.map((category) => (
              <CategoryBlock
                categories={categories}
                legalEntities={legalEntities}
                customCategory={category}
                key={category.id}
                canEditLedgerAccountAssignments={canManageCustomCategoriesAccounts}
              />
            ))}
          </List>
        )}
        {addCustomCategoryModalOpen && (
          <CreateCustomCategoryModal
            parentCategories={categories}
            legalEntities={legalEntities}
            onClose={() => setAddCustomCategoryModalOpen(false)}
            canEditLedgerAccountAssignments={canManageCustomCategoriesAccounts}
          />
        )}
      </Box>
    </ResponsivePage.Body>
  )
}

export default CustomCategoriesPage
